import type { WorkspaceDoc } from '@/lib/sync/entity-types';

/**
 * Filter + order the canvas list for the `/canvas` embed picker.
 *
 * Keeps only canvas-kind, non-archived entities, matches the title against the
 * case-insensitive query, orders most-recently-updated first, and caps results.
 */
export function filterCanvases(
  docs: readonly WorkspaceDoc[],
  query: string,
  limit = 50,
): WorkspaceDoc[] {
  const q = query.trim().toLowerCase();
  const base = docs.filter((d) => d.kind === 'canvas' && !d.isArchived);
  const matched = q
    ? base.filter((d) => (d.title || 'Untitled').toLowerCase().includes(q))
    : base;
  return [...matched]
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
    .slice(0, limit);
}
